import { useClientId } from "@/features/clients/detail/use-client-id";
import { PaymentsPage } from "@/features/payments/payments-page";

export function ClientPaymentsPage() {
  const clientId = useClientId();
  return <PaymentsPage clientId={clientId} embedded />;
}
